import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { JioMediaPlayerImplementation } from '@commoncore/implementation/JioMediaPlayerImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { PingService } from '@commoncore/services/ping.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
declare var mediaplayer: any;

@Component({
  selector: 'common-jio-media-player',
  templateUrl: './jio-media-player.component.html',
  styleUrl: './jio-media-player.component.scss'
})
export class JioMediaPlayerComponent implements OnInit, OnDestroy {

  private jioMediaPlayerImpl: JioMediaPlayerImplementation;
  public universalService: any;
  @Input() previewDirection: any;
  @Output('previewError') isErrorInPreviewing: EventEmitter<boolean> = new EventEmitter<boolean>();
  pingService: any;
  mediaPlayer: any | null;
  options = {
    src: "",
    speed: [
      { label: '0.5px', value: 0.5, index: 0 },
      { label: '0.75px', value: 0.75, index: 1 },
      { label: '1x', value: 1, index: 2, isActive: true },
      { label: '1.25x', value: 1.25, index: 3 },
      { label: '1.5x', value: 1.5, index: 4 },
      { label: '2x', value: 2, index: 5 }
    ],
    allowCredentials: { licence: false, manifest: true, segments: true },

  }
  lazyInjectorService: any;

  constructor(private globalService: GlobalService, private renderer2: Renderer2) {
    this.universalService = this.globalService.getUniversalServiceRef();
    this.pingService = PingService.getInstance(globalService);
    this.lazyInjectorService = this.globalService.getLazyInjectorServiceRef();
  }

  ngOnInit(): void {
    this.universalService.videoClapperRunning = true
    this.jioMediaPlayerImpl = this.getMediaPlayerImplRef();
    if (this.universalService.activeRepo == ActiveRepo.MAIN) { // Lazy loading in main repo only
      this.injectMediaPlayer();
    } else {
      this.openMediaPlayer(); //play directly
    }
  }


  getMediaPlayerImplRef() {
    return JioMediaPlayerImplementation.getInstance(this.globalService);
  }

  async openMediaPlayer() {
    var self = this;
    var playbackUrl = "";
    if (self.universalService.selectedFile["mimeType"] == 'video') {
      try {
        this.setupMediaPlayer(); //pre setup of media player
        playbackUrl = await self.jioMediaPlayerImpl.getVideoPlaybackUrl();
      } catch (error) {
        if (self.jioMediaPlayerImpl == null || self.jioMediaPlayerImpl == undefined) {
          self.jioMediaPlayerImpl = self.getMediaPlayerImplRef();
          if (self.jioMediaPlayerImpl) {
            playbackUrl = await self.jioMediaPlayerImpl.getVideoPlaybackUrl();
          }
          console.log("Handled Error",error);
        }
      }
    }

    self.jioMediaPlayerImpl.getPlaybackSourceUrl(playbackUrl).subscribe(
      suc => {
        self.playVideoMedia(suc)
        self.jioMediaPlayerImpl.getTokenFromMediaAuth(suc);
      },
      error => {
        self.isErrorInPreviewing.emit(true);
        self.universalService.showErrorMessage(error);
      }
    )
  }

  setupMediaPlayer() {
    if (!this.mediaPlayer) {
      this.mediaPlayer = mediaplayer.setup('video-media-content'); //setup player.

      //Below two lines will add mediastatus & mediaerror event to mediaplayer.
      this.mediaPlayer.addEventListener('mediastatus', (event) => {
        this.jioMediaPlayerImpl.mediaPlayerStatusFnc(event, mediaplayer);
      });
      this.mediaPlayer.addEventListener('mediaerror', (event) => {
        this.jioMediaPlayerImpl.mediaPlayerErrorFnc(event, mediaplayer)
      });
      this.handleVideoPlayerEvents();
      this.jioMediaPlayerImpl.retryCount = 0;
    }
  }

  playVideoMedia(streamingUrl) {
    this.options["src"] = streamingUrl;
    mediaplayer.load(this.options); //load playback data
    this.jioMediaPlayerImpl.togglePreviewButtons();
  }

  handleVideoPlayerEvents() {
    AppEvents.on("FULLSCREEN", () => {
      $("#video-media-content #fullscreen-button-desktop").trigger('click');
    });

    AppEvents.on(EventsList.VIDEO_PLAYER_RETRY, () => {
      //mediaplayer.destroy(); // this is not need here, as setupMediaPlayer() has check to avoid instances
      this.openMediaPlayer();
    });

    //To pause video player when there is 2fa popup, no internet, such scenario
    AppEvents.on(EventsList.VIDEO_PLAYER_PAUSE, () => {
      this.pauseMediaPlayer();
    });
  }

  pauseMediaPlayer() {
    if (mediaplayer.getCurrentState() == 'play') {//pause if in play state
      mediaplayer.pause(); // pause
    }
  }

  ngOnDestroy() {
    this.jioMediaPlayerImpl = null;
    this.isErrorInPreviewing = null;
    this.universalService.videoClapperRunning = false;
    this.pingService.clearInterval();

    //Below two lines will remove mediastatus & mediaerror event on destroy.
    this.mediaPlayer.removeEventListener('mediastatus', (event) => {
      this.jioMediaPlayerImpl.mediaPlayerStatusFnc(event, mediaplayer);
    });
    this.mediaPlayer.removeEventListener('mediaerror', (event) => {
      this.jioMediaPlayerImpl.mediaPlayerErrorFnc(event, mediaplayer)
    });
    this.mediaPlayer = null; //free up player instance.
    mediaplayer.destroy();
  }

  injectMediaPlayer() {
    var self = this;
    //this.lazyInjectorService.lazyInjectCss('mediaplayer', this.renderer2);

    //lazy loading script and check if loaded then we open 
    this.lazyInjectorService.LazyInjectVideoPlayerScript('mediaplayer').then(() => {
      self.openMediaPlayer(); // Call to open media post load is success
    })
      .catch((error) => {
        console.error('Error loading  Jio Video Player Script :', error);
        //self.injectMediaPlayer();//try again
      });
  }
}
